exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".desktop-secondary-nav .secondary-link{font-size:14px!important;color:#666;font-weight:700!important;text-decoration:none;white-space:nowrap}.desktop-secondary-nav .secondary-link:not(:first-child){padding-left:40px}.desktop-secondary-nav .secondary-link.active{color:#1e88e5;font-weight:900!important;text-decoration:none!important}.desktop-secondary-nav .secondary-link:hover{color:#1e88e5;text-decoration:none!important}", ""]);

// exports
